/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable prefer-destructuring */
// Airline code => SeatClass code => Class details
import { toUpper } from 'lodash';

const mapping = {
  VJ: {
    PROMO: {
      cabin: 'Economy',
      cabin_detail_en: 'Promotion',
      cabin_detail_vi: 'Khuyến mại',
      seat_class: 'Phổ thông',
      hand_baggage: 'NA',
      allowance_baggage: 'NA',
      meal: 'NA',
      refund_ticket: 'NA',
      update_ticket: 'NA',
    },
    ECO: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy',
      cabin_detail_vi: 'Tiết Kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '7kg',
      allowance_baggage: '0kg',
      meal: 'Không có sẵn, chọn thêm khi mua vé',
      refund_ticket:
        '- Hoàn định danh free 180 ngày\n- Hoàn mất phí 385,000đ trước 24 tiếng',
      update_ticket: '385,000đ + Chênh lệch vé, trước 3 tiếng',
    },
    SKYBOSS: {
      cabin: 'Skyboss',
      cabin_detail_en: 'Skyboss',
      cabin_detail_vi: 'Skyboss',
      seat_class: 'Thương gia',
      hand_baggage: '10kg',
      allowance_baggage: '30kg',
      meal: 'Không có sẵn, chọn thêm khi mua vé',
      refund_ticket:
        '- Hoàn định danh free 1 năm\n- Hoàn mất phí 385,000đ trước 3 tiếng',
      update_ticket: 'Free + Chênh lệch vé, trước 3 tiếng',
    },
    DELUXE: {
      cabin: 'Deluxe',
      cabin_detail_en: 'Deluxe',
      cabin_detail_vi: 'Deluxe',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '7kg',
      allowance_baggage: '20kg',
      meal: 'Không có sẵn, chọn thêm khi mua vé',
      refund_ticket:
        '- Hoàn định danh free 180 ngày\n- Hoàn mất phí 385,000đ trước 24 tiếng',
      update_ticket: 'Free + Chênh lệch vé, trước 3 tiếng',
    },
  },
  VN: {
    A: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Super Lite',
      cabin_detail_vi: 'Phổ thông siêu tiết kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '0kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Không',
      update_ticket: 'Không',
    },
    B: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Flex',
      cabin_detail_vi: 'Phổ thông linh hoạt',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    C: {
      cabin: 'Business',
      cabin_detail_en: 'Business Flex',
      cabin_detail_vi: 'Thương gia linh hoạt',
      seat_class: 'Thương gia',
      hand_baggage: '18kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '32kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free',
    },
    D: {
      cabin: 'Business',
      cabin_detail_en: 'Business Classic',
      cabin_detail_vi: 'Thương gia tiêu chuẩn',
      seat_class: 'Thương gia',
      hand_baggage: '18kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '32kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
    E: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Lite',
      cabin_detail_vi: 'Phổ thông tiết kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
    G: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Super Lite',
      cabin_detail_vi: 'Phổ thông siêu tiết kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '0kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Không',
      update_ticket: 'Không',
    },
    H: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    I: {
      cabin: 'Business',
      cabin_detail_en: 'Business Classic',
      cabin_detail_vi: 'Thương gia tiêu chuẩn',
      seat_class: 'Thương gia',
      hand_baggage: '18kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '32kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
    J: {
      cabin: 'Business',
      cabin_detail_en: 'Business Flex',
      cabin_detail_vi: 'Thương gia linh hoạt',
      seat_class: 'Thương gia',
      hand_baggage: '18kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '32kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free',
    },
    K: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    L: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    M: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Flex',
      cabin_detail_vi: 'Phổ thông linh hoạt',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    N: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    P: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Super Lite',
      cabin_detail_vi: 'Phổ thông siêu tiết kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '0kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Không',
      update_ticket: 'Không',
    },
    Q: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    R: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Classic',
      cabin_detail_vi: 'Phổ thông tiêu chuẩn',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    S: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Flex',
      cabin_detail_vi: 'Phổ thông linh hoạt',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    T: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Lite',
      cabin_detail_vi: 'Phổ thông tiết kiệm',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
    U: {
      cabin: 'Economy Premium',
      cabin_detail_en: 'Premium Economy Classic',
      cabin_detail_vi: 'Phổ thông đặc biệt tiêu chuẩn',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
    W: {
      cabin: 'Economy Premium',
      cabin_detail_en: 'Premium Economy Flex',
      cabin_detail_vi: 'Phổ thông đặc biệt linh hoạt',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free',
    },
    Y: {
      cabin: 'Economy',
      cabin_detail_en: 'Economy Flex',
      cabin_detail_vi: 'Phổ thông linh hoạt',
      seat_class: 'Phổ thông',
      hand_baggage: '12kg',
      hand_baggage_bl: '8kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Free, Tết thu phí 360,000đ',
    },
    Z: {
      cabin: 'Economy Premium',
      cabin_detail_en: 'Premium Economy Classic',
      cabin_detail_vi: 'Phổ thông đặc biệt tiêu chuẩn',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '12kg',
      hand_baggage_bl: '7kg',
      allowance_baggage: '23kg',
      meal: 'Chuyến bay >= 1h30p sẽ có bữa ăn',
      refund_ticket: 'Phí 500,000đ',
      update_ticket: 'Phí 360,000đ',
    },
  },
  QH: {
    ECONOMYSAVER: {
      cabin: 'Bamboo Eco',
      cabin_detail_en: 'Bamboo Eco',
      cabin_detail_vi: 'Bamboo Eco',
      seat_class: 'Phổ thông',
      hand_baggage: '7kg',
      allowance_baggage: '20kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket: 'Không',
      update_ticket:
        '- Trước 3 tiếng: 270,000đ + Chênh lệch\n- Sau đó: không áp dụng',
    },
    PREMIUMSMART: {
      cabin: 'Bamboo Premium',
      cabin_detail_en: 'Bamboo Premium',
      cabin_detail_vi: 'Bamboo Premium',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '7kg',
      allowance_baggage: '30kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 350,000đ + Chênh lệch. Tết thì 550,000đ + Chênh lệch',
      update_ticket: '- Bất kỳ: 270,000đ + Chênh lệch',
    },
    BUSINESSSMART: {
      cabin: 'Bamboo Business',
      cabin_detail_en: 'Bamboo Business',
      cabin_detail_vi: 'Bamboo Business',
      seat_class: 'Thương gia',
      hand_baggage: '2 túi 7kg = 14 kg',
      allowance_baggage: '40kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 350,000đ + Chênh lệch. Tết thì 550,000đ + Chênh lệch',
      update_ticket:
        '- Trước 3 tiếng: free + chênh lệch\n- Sau đó: 270,000đ + Chênh lệch',
    },
    BUSINESSFLEX: {
      cabin: 'Bamboo Business',
      cabin_detail_en: 'Bamboo Business',
      cabin_detail_vi: 'Bamboo Business',
      seat_class: 'Thương gia',
      hand_baggage: '2 túi 7kg = 14 kg',
      allowance_baggage: '40kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 350,000đ + Chênh lệch. Tết thì 550,000đ + Chênh lệch',
      update_ticket:
        '- Bất kỳ: Free + Chênh lệch\n- Tết & trong 3 tiếng: 270,000đ + chênh lệch',
    },
    PREMIUMFLEX: {
      cabin: 'Bamboo Premium',
      cabin_detail_en: 'Bamboo Premium',
      cabin_detail_vi: 'Bamboo Premium',
      seat_class: 'Phổ thông đặc biệt',
      hand_baggage: '7kg',
      allowance_baggage: '30kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 350,000đ + Chênh lệch. Tết thì 550,000đ + Chênh lệch',
      update_ticket:
        '- Bất kỳ: Free + Chênh lệch\n- Tết & trong 3 tiếng: 270,000đ + chênh lệch',
    },
    ECONOMYSAVERMAX: {
      cabin: 'Bamboo Eco',
      cabin_detail_en: 'Bamboo Eco',
      cabin_detail_vi: 'Bamboo Eco',
      seat_class: 'Phổ thông',
      hand_baggage: '7kg',
      allowance_baggage: '0kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket: 'Không',
      update_ticket: 'Không',
    },
    ECONOMYSMART: {
      cabin: 'Bamboo Eco',
      cabin_detail_en: 'Bamboo Eco',
      cabin_detail_vi: 'Bamboo Eco',
      seat_class: 'Phổ thông',
      hand_baggage: '7kg',
      allowance_baggage: '20kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 550,000đ + Chênh lệch',
      update_ticket:
        '- Trước 3 tiếng: 270,000đ + Chênh lệch\n- Sau đó: 550,000đ + Chênh lệch',
    },
    ECONOMYFLEX: {
      cabin: 'Bamboo Eco',
      cabin_detail_en: 'Bamboo Eco',
      cabin_detail_vi: 'Bamboo Eco',
      seat_class: 'Phổ thông',
      hand_baggage: '7kg',
      allowance_baggage: '20kg',
      meal: 'Chuyến bay >= 1h45p sẽ có bữa ăn',
      refund_ticket:
        '- Trước 3 tiếng: 350,000đ + Chênh lệch\n- Sau đó: 350,000đ + Chênh lệch. Tết thì 550,000đ + Chênh lệch',
      update_ticket:
        '- Bất kỳ: Free + Chênh lệch\n- Tết: 270,000đ + Chênh lệch',
    },
  },
};

export enum AirlineCode {
  VJ = 'VJ',
  VN = 'VN',
  QH = 'QH',
  VU = 'VU',
}
export type AddonMappingReturn = {
  cabin: string;
  cabin_detail_en: string;
  cabin_detail_vi: string;
  seat_class: string;
  hand_baggage: string;
  hand_baggage_bl?: string;
  allowance_baggage: string;
  meal: string;
  refund_ticket: string;
  update_ticket: string;
};

export type AddonMappingReturnV2 = {
  id: string,
  airline: string,
  class: string,
  cabin: string,
  detail_en: string,
  operating_airline: string,
  detail_vi: string,
  seat_class: string,
  from_date: string,
  to_date: string,
  is_baggage: boolean | string,
  baggage_quantity: string,
  baggage_weight: string,
  is_allowance_baggage: boolean | string,
  allowance_baggage_quantity: string,
  allowance_baggage_weight: string,
  allowance_baggage_note: string,
  is_meal: boolean | string,
  meal_duration: string,
  refund_method: string,
  expired_time_refund: string,
  time_from_refund: string,
  time_to_refund: string,
  reason_refund_1: string,
  is_refund_1: boolean | string,
  refund_fee_1: string,
  time_from_refund_2: string,
  time_to_refund_2: string,
  reason_refund_2: string,
  is_refund_2: boolean | string,
  refund_fee_2: string,
  time_from_update_1: string,
  time_to_update_1: string,
  is_update_ticket_1: boolean | string,
  update_fee_1: string,
  time_from_update_2: string,
  time_to_update_2: string,
  is_update_ticket_2: boolean | string,
  update_fee_2: string,
  is_update_name: boolean | string,
  update_name_from: string,
  update_name_to: string,
  update_name_fee: string,
  is_update_route_at_airport: boolean | string,
  fee_update_route_at_airport: string,
  is_drop_out_route: boolean | string,
  fee_drop_out_route: string,
  has_priority_counters: boolean | string,
  has_business_room: boolean | string,
  has_plus_point: boolean | string,
  is_select_seat: string
  list_class_same_config: string[]
};

export type RefundPolicyConfigItem = {
  id: number;
  name: string;
  value: string;
};

// eslint-disable-next-line max-len
export const addonMapping = (
  airlineCode: string,
  classCode: string,
): AddonMappingReturn | AddonMappingReturnV2 | null => {
  let parsedSeatClass = toUpper(classCode);
  if (airlineCode === 'VJ') {
    parsedSeatClass = (parsedSeatClass || '').split('_')[1];
  }
  const airlineClassObj = (mapping as any)[airlineCode];
  if (airlineClassObj && parsedSeatClass) {
    if (airlineCode === AirlineCode.VJ) {
      const matchingClassCode = Object.keys(airlineClassObj).find(
        (objClassCode) => parsedSeatClass.toUpperCase().includes(objClassCode),
      );
      return matchingClassCode ? airlineClassObj[matchingClassCode] : null;
    }
    return airlineClassObj[parsedSeatClass];
  }
  return null;
};

export const checkAddonBaggage = (addon: AddonMappingReturn) => {
  const {
    hand_baggage: handBaggage,
    hand_baggage_bl: handBaggageBl,
    allowance_baggage: allowanceBaggage,
  } = addon;

  const unavailableArr = [
    'Không',
    'NA',
    '0kg',
    'Không có sẵn, chọn thêm khi mua vé',
  ];

  const isHandBaggageAvailable = !unavailableArr.includes(handBaggage);
  const isHandBaggageBLAvailable = handBaggageBl && !unavailableArr.includes(handBaggageBl)
    ? handBaggageBl
    : false;
  const isAllowanceBaggageAvailable = !unavailableArr.includes(allowanceBaggage);
  return {
    isHandBaggageAvailable,
    isHandBaggageBLAvailable,
    isAllowanceBaggageAvailable,
  };
};

export const addonMappingV2 = ({
  airlineCode, classCode, cabin, fareConfig, fareRules, isTetDay,
}: {
  airlineCode: string,
  classCode: string,
  cabin: string,
  fareConfig?: AddonMappingReturnV2[],
  fareRules?: any,
  isTetDay?: boolean }): AddonMappingReturnV2 | null => {
  const _fareConfig = fareRules || fareConfig;
  let obj = null;
  if (isTetDay) {
    obj = _fareConfig.find((f: any) => {
      if (f.operating_airline === 'QH') {
        return f.operating_airline === airlineCode && f.cabin === cabin && f?.list_class_same_config?.map((c: string) => c.toUpperCase())?.includes(classCode.toUpperCase()) && f.from_date === '06/01/2025' && f.to_date === '07/02/2025';
      }

      return f.operating_airline === airlineCode && f?.list_class_same_config?.map((c: string) => c.toUpperCase())?.includes(classCode.toUpperCase()) && f.from_date === '06/01/2025' && f.to_date === '07/02/2025';
    });
  } else {
    obj = _fareConfig.find((f: any) => {
      if (f.operating_airline === 'QH') {
        return f?.cabin === cabin && f.operating_airline === airlineCode && f.from_date !== '06/01/2025' && f?.list_class_same_config?.map((c: string) => c.toUpperCase())?.includes(classCode.toUpperCase());
      }

      return f?.list_class_same_config?.map((c: string) => c.toUpperCase())?.includes(classCode.toUpperCase()) && f.operating_airline === airlineCode && f.from_date !== '06/01/2025';
    });
  }
  return obj || null;
};

export const addonMappingCabin = (
  fareConfig: AddonMappingReturnV2[],
  airlineCode?: string,
  cabinCode?: string,
  fareRules?: any,
): AddonMappingReturnV2 | null => {
  const _fareConfig = fareRules || fareConfig;

  // console.log('🚀 ~ fareRules', fareRules);
  // console.log(' addonMappingCabin => cabinCode', cabinCode);

  const obj = _fareConfig.find((f: any) => f.cabin?.toUpperCase() === cabinCode?.toUpperCase() && f.airline === airlineCode);
  return obj || null;
};

export const getFlightRefundPolicy = (refundPolicyConfig = [], airline = '', locale = 'Vi-VN') => {
  const formatLocale = locale?.split('-')?.[0];
  const selectedPolicy: any = refundPolicyConfig?.find((item: any) => item?.name?.includes(formatLocale) && item?.name?.includes(airline));
  return selectedPolicy?.value?.replaceAll('ol', 'ul')?.replaceAll('19px', '18px') || '';
};
